export default "__VITE_ASSET__ffd43b3d__"